import styled from 'styled-components'
import Default from '../assets/images/Default.svg'
import Disabled from "../assets/images/Disabled.svg";
import Pointer from "../assets/images/Pointer.svg";
const formBreakpoint = '999.9px'

export const InputBase = styled.input`
  font: inherit;
  color: currentColor;
  width: 100%;
  border: 0;
  outline: 0;
  display: block;
  background: none;
  box-sizing: content-box;
`

export const ButtonBase = styled.button`
  border: 0;
  outline: 0;
  display: inline-flex;
  position: relative;
  align-items: center;
  justify-content: center;
  text-align: center;
  background: none;
  font: inherit;
  cursor: url(${Pointer}), auto;
  user-select: none;
  white-space: nowrap;

  &[disabled] {
    cursor: url(${Disabled}), auto;
  }
`

export const Popover = styled.div`
  position: absolute;
  top: 105%;
  left: 0;
  outline: 0;
  background: none;
  overflow: hidden;
  cursor: url(${Default}), default;
  box-shadow: 0px 6px 6px rgba(0, 0, 0, 0.08);
  border-radius: 0.8rem;
  z-index: var(--modal-z-index);

  @media (max-width:${formBreakpoint}) {
    top: 110%;
    width: 100%;
  }
`
